<div class="main-container">
    <p-card>
        <div class="content-container">
            <p-messages [(value)]="messages" [enableService]="false" [closable]="false" />
            <div class="login-button-container">
                <p-button label="Login" (onClick)="login()"></p-button>
            </div>
        </div>
    </p-card>
</div>